import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00E676',
    },
    background: {
      default: '#1A1E2A',
      paper: '#212737',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#A1A7BB',
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#212737',
          boxShadow: 'none',
        },
      },
    },
  },
});

export default theme;